<template>
    <div>
        <!-- 编辑、添加界面 -->
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="570px" :destroy-on-close="true"
            :before-close="cancel">
            <el-form label-width="120px" ref="form" :model="form" :rules="rules">
                <el-form-item label="付款单位" prop="invoiceTitle"
                    :rules="{ required: true, message: '请选择付款单位', trigger: 'change' }">
                    <el-input style="width: 300px;" v-model="form.invoiceTitle" auto-complete="off"
                        placeholder="请选择付款单位" :disabled="type === 'claim'"></el-input>
                </el-form-item>
                <el-form-item label="收款单位" prop="receivingUnitId"
                    :rules="{ required: true, message: '请选择收款单位', trigger: 'change' }">
                    <el-select v-model="form.receivingUnitId" style="width: 300px;" filterable placeholder="请输入收款单位"
                        :disabled="type === 'claim'">
                        <el-option v-for="(item, index) in businessOption" :key="index" :label="item.companyName"
                            :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
               <el-form-item label="合同" prop="contractId"
                    :rules="{ required: type === 'claim', message: '请选择合同', trigger: 'change' }">
                   <el-select :disabled="type !== 'claim'" v-model="form.contractId" style="width: 300px;"
                        filterable remote placeholder="请输入合同编号" :remote-method="remoteMethod"
                        :loading="loading" @change="value => getContractAmount(value)">
                        <el-option v-for="item in contractOption" :key="item.id"
                            :label="item.contractNumber + '-' + item.contractName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同金额" prop="contractAmount" v-if="type === 'claim'">
                   <el-input size="small" v-model="form.contractAmount" auto-complete="off" style="width: 300px;"
                        disabled placeholder="请输入合同金额"></el-input>
                </el-form-item>
                <el-form-item label="垫付款金额" prop="paymentAmount">
                    <el-input size="small" v-model="form.paymentAmount" auto-complete="off" style="width: 300px;"
                        :disabled="type === 'claim'" placeholder="请输入垫付款金额"></el-input>
                </el-form-item>
                <el-form-item label="垫付款日期" prop="paymentDate">
                    <el-input style="width: 300px;" size="small" v-model="form.paymentDate" auto-complete="off"
                        :disabled="type === 'claim'" placeholder="请输入日期，格式yyyy-MM-dd"></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input style="width: 300px;" :autosize="{ minRows: 3 }" type="textarea" maxlength="300"
                        :disabled="type === 'claim'" show-word-limit placeholder="请输入内容"
                        v-model="form.remark">
                    </el-input>
                </el-form-item>
                <el-form-item label="认领附件" prop="file" v-if="type === 'claim'">
                    <div style="display: flex;align-items: center">
                        <el-input style="width: 300px;" v-model="fileName" readonly></el-input>
                        <el-upload style="margin-left: 10px" class="upload-demo" action="" :auto-upload="false"
                            :show-file-list="false" :on-change="handleChange" :file-list="fileList"
                            :on-exceed="handleExceed">
                            <el-button size="small" icon="el-icon-plus" type="primary"></el-button>
                        </el-upload>
                        <el-button size="small" style="margin-left: 10px" type="danger" icon="el-icon-delete"
                            @click="handleRemove"></el-button>
                    </div>
                </el-form-item>
                <el-form-item label="认领备注" prop="claimRemark" v-if="type === 'claim'">
                    <el-input style="width: 300px;" :autosize="{ minRows: 3 }" type="textarea" maxlength="300"
                        show-word-limit placeholder="请输入内容" v-model="form.claimRemark">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="cancel">取消</el-button>
                <el-button size="small" type="primary" class="title" @click="handle">提交</el-button>
            </div>
        </el-dialog>
        <loading :loading="dataLoading" load-text="数据加载中"></loading>
    </div>
</template>

<script>

import { addAdvance, claimAdvance, editAdvance } from "@/api/dilivery/advance";
import { checkDate } from "@/utils/rules";
import { padDate } from "@/store/date";
import { getCompanyPage } from "@/api/dilivery/company";
import { getAllContract } from "@/api/dilivery/sales/contract";
import Loading from "@/components/loading/Loading.vue";


export default {
    name: "AddEditPayment",
    components: {
        Loading
    },
    props: {
        showDialog: {
            default: false
        },
        type: {
            default: ''
        },
        selectDetail: {
            default: () => ({})
        }
    },
    data() {
        return {
            title: '',
            loading: false,
            dataLoading: false,
            contractOption:[],
            businessOption: [],
            fileName: '',
            fileList: [],
            form: {
                id:'',
                contractId: '',
                contractNumber: '',
                contractAmount: '',
                invoiceTitle: '',
                receivingUnitId: '',
                paymentAmount: '',
                paymentDate: '',
                remark: '',
                claimRemark:'',
                file:null
            },
            rules: {
                contractAmount:[
                    {
                        validator: (rule, value, callback) => {
                            if (Number(value) !== Number(this.form.paymentAmount)) {
                                return callback(new Error('合同金额需与垫付款金额一致'));
                            }
                            return callback(); // 验证通过
                        }, trigger: 'change'
                    }
                ],
                paymentAmount: [
                    { required: true, message: '请输入垫付款金额', trigger: 'change' },
                    {
                        validator: (rule, value, callback) => {
                            if (isNaN(value)) {
                                return callback(new Error('请输入数字值'));
                            }
                            if (value <= 0) {
                                return callback(new Error('金额必须大于0'));
                            }
                            return callback(); // 验证通过
                        }, trigger: 'change'
                    }
                ],
                paymentDate: [
                    { required: true, message: '请选择添加垫付款时间', trigger: 'change' },
                    { validator: checkDate, trigger: 'change' }
                ]
            },
        }
    },
    computed: {
        contractAmount() {
            let contract = this.contractOption.find(item => item.id === this.form.contractId)
            this.form.contractAmount = contract ? contract.contractAmount : ''
            return contract ? contract.contractAmount : 0
        }
    },
    watch: {
        type: {
            handler(newVal) {
                if (newVal) {
                    if (newVal === 'edit') {
                        this.title = '编辑垫付款信息'
                    } else if (newVal === 'claim') {
                        this.title = '垫付款信息认领'
                    } else {
                        this.title = '添加垫付款信息'
                    }
                }
            },
            immediate: true
        },
        selectDetail: {
            handler(newVal) {
                if (newVal && Object.keys(newVal)) {
                    this.form.id = newVal.id
                    this.form.invoiceTitle = newVal.invoiceTitle
                    this.form.receivingUnitId = newVal.receivingUnitId
                    this.form.contractId = newVal.contractId
                    this.form.paymentAmount = newVal.paymentAmount
                    this.form.paymentDate = newVal.paymentDate
                    this.form.remark = newVal.remark
                }
            },
            immediate: true
        },
    },
    mounted() {
        this.dataLoading = true
        Promise.all([
            this.remoteMethod(),
            this.getBusinessOption()
        ]).finally(() => {
            this.dataLoading = false
        })
    },
    methods: {
        handleExceed(files) {
            this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传');
        },
        handleChange(file, fileList) {
            this.form.file = file
            this.fileList = [file]
            this.fileName = file.name
        },
        handleRemove(file, fileList) {
            this.form.file = null
            this.fileList = []
            this.fileName = ''
        },
        getContractAmount(value) {
            let contract = this.contractOption.find(item => item.id === value)
            if (contract) {
                this.form.contractAmount = contract.contractAmount
            } else {
                this.form.contractAmount = ''
            }
        },
        remoteMethod(query) {
            try {
                this.contractOption = [];
                this.loading = true;
                let data = {
                    "query#trusteeCompanyId.IN": this.selectDetail.receivingUnitId,
                }
                if (query) {
                    data["query#contractNumber.LIKE"] = query
                }
                getAllContract('ADVANCE_PAYMENT_CONTRACT', data).then(res => {
                    if (res.code === 200) {
                        this.loading = false;
                        this.contractOption = res.data
                    }
                })
            } catch (error) {
                console.log(error);
                this.contractOption = [];
                this.loading = false;
            }
        },
        getBusinessOption() {
            try {
                let params = {
                    'page.current': 1,
                    'page.size': 500,
                    'order': 'id.asc'
                }
                getCompanyPage(params, {}).then(res => {
                    if (res.code === 200) {
                        this.businessOption = res.data.records
                    }
                })
            } catch (error) {
                console.log(error);
            }
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        handle() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.form.paymentDate = padDate(this.form.paymentDate)
                    if (this.type === 'edit') {
                        editAdvance([this.form]).then(res => {
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('修改成功')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                        })
                    } else if (this.type === 'add') {
                        addAdvance([this.form]).then(res => {
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('提交成功')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                        })
                    } else {
                        let data = {
                            id: this.form.id,
                            contractId: this.form.contractId,
                            remark: this.form.claimRemark
                        }
                        const formData = new FormData();
                        const jsonStr = JSON.stringify(data);
                        const blob = new Blob([jsonStr], {
                            type: 'application/json'
                        });
                        formData.append("info", blob);
                        if (this.form.file) {
                            formData.append('file', this.form.file.raw); // 文件
                        }
                        claimAdvance(formData).then(res => {
                            if (res.code === 200) {
                                this.$emit('submit', 'confirm')
                                this.$messageUi.success('申请认领成功')
                                this.$store.commit('right/setChangeRed', true)
                            }
                        }).catch(err => {
                        })
                    }
                } else {
                    this.$nextTick(() => {
                        let err = document.getElementsByClassName('is-error')
                        if (err.length) {
                            err[0].scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            })
                        }
                    })
                    this.$messageUi.error('填写参数不规范，请检查')
                }
            })
        }
    },

}
</script>

<style scoped>
</style>
